import { render, staticRenderFns } from "./monitorDetail.vue?vue&type=template&id=c1c0057e&scoped=true"
import script from "./monitorDetail.vue?vue&type=script&lang=js"
export * from "./monitorDetail.vue?vue&type=script&lang=js"
import style0 from "./monitorDetail.vue?vue&type=style&index=0&id=c1c0057e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c0057e",
  null
  
)

export default component.exports